<template>
  <div class="main-child">
    <v-container fluid grid-list-xl page class="child-1" style="overflow: hidden;">
      <app-canvas v-for="(canvas, index) in flows" :key="index" :flow="canvas" v-show="canvas == flow"  :lines="lines" :showJSON="showJSON">{{ canvas }}</app-canvas>
    </v-container>
  </div>
</template>
<script>
// eslint-disable-next-line
import VueDraggableResizable from "vue-draggable-resizable";
import AppCanvas from "./canvas";
export default {
  components: { AppCanvas },
  props: {
    flows: {
      type: Array
    },
    flow: {
      type: String,
      default: "Flow 1"
    },
    showJSON: {
      type: Boolean
    }
  },
  data() {
    return {
      page: {
        title: "Blank Page",
        headline: "Black Page",
        description: `A blank page is good to quick-start from scratch.`
      },
      breadcrumbs: [
        {
          text: "Src",
          disabled: false
        },
        {
          text: "Views",
          disabled: false
        },
        {
          text: "Blank",
          disabled: false
        }
      ],
      lines: []
    };
  },
  created() {
    this.$store.dispatch("updateJSON", JSON.parse(localStorage.getItem('updateJSON')));
  },
 
};
</script>
<style scoped>
.main-child {
  display: flex;
  width: 100%;
  height: 100%;
}

.child-1 {
  padding: 0px;
  margin: 0px;
  display: flex;
}
</style>
